/* Production My Stats — placeholder for iter97.20.
 * Shows the production tech their personal performance metrics.
 * Backend aggregator endpoint pending; this page is a coming-soon stub
 * so the sidebar item routes to a meaningful screen instead of 404'ing.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ChartLineUp, ArrowRight } from "@phosphor-icons/react";


export default function ProductionMyStats() {
    return (
        <div className="space-y-5 min-w-0" data-testid="production-my-stats-page">
            <header>
                <h1 className="font-display text-3xl font-bold tracking-tight">My Stats</h1>
                <p className="text-sm text-muted-foreground mt-1">
                    Your personal performance metrics — cases completed, QC first-pass rate, average TAT, material waste score.
                </p>
            </header>
            <div className="rounded-2xl bg-card border border-border p-10 text-center">
                <ChartLineUp size={36} weight="duotone" className="mx-auto text-primary mb-3" />
                <div className="font-display text-base font-semibold">Personal stats — coming next iteration</div>
                <div className="text-sm text-muted-foreground mt-2 max-w-md mx-auto leading-relaxed">
                    We're wiring up cases-completed, QC pass-rate, average TAT, material waste score,
                    rework count, and a 4-week trend chart — all scoped to just you.
                </div>
                <Link
                    to="/coe/production"
                    className="inline-flex items-center gap-1.5 mt-5 text-xs font-semibold text-primary hover:underline"
                >
                    Back to Dashboard <ArrowRight size={11} weight="bold" />
                </Link>
            </div>
        </div>
    );
}
